// The page a signed-out person asked for survives the trip through sign-in and organization selection.
const KEY = 'signInReturn';
const NO_RETURN = ['/sign-in', '/select-organization'];

// Only a path on this origin is kept, so a crafted sign-in link cannot send anyone off-site.
export function safeReturnPath(
  value: string | null | undefined
): string | null {
  if (!value?.startsWith('/') || value.startsWith('//')) {
    return null;
  }
  let url: URL;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return null;
  }
  if (
    url.origin !== window.location.origin ||
    url.pathname === '/' ||
    NO_RETURN.some((path) => url.pathname.startsWith(path))
  ) {
    return null;
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

export function rememberReturn(referrer: string | null) {
  const path = safeReturnPath(referrer);
  if (!path) {
    return;
  }
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // without storage the person lands on the dashboard and opens the link again
  }
}

export function takeReturn(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return safeReturnPath(value);
  } catch {
    return null;
  }
}
